const navBtn =document.querySelector("nav button")
const navLinks=document.querySelector("nav")
const media=window.matchMedia("(min-width:992px)")
navBtn.addEventListener("click",()=>{
    navLinks.classList.toggle("active")
})
media.addEventListener("change",(e)=>{
    if(e.matches){

        navLinks.classList.remove("active")
        
        navBtn.style.display="none"
    }else{
        navBtn.style.display="block"

    }
})